module.exports = __webpack_public_path__ + "img/footer-logo-believe-specialist-finance.44324ea7.svg";